import { Component, OnInit } from '@angular/core';
import { WalkAndWinNavItems } from '../../walkwin/walkwin.nav';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {

  public sidebarMinimized = false;
  public navItems = WalkAndWinNavItems;
  // public navItems = expertSanteNavItems.map(items => { this.translateNav(items); return items; });
  public selectedApplication: any = null; // Application sélectionnée

  public locale: string | null = 'fr';

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {
  }

  toggleMinimize(e: any) {
    this.sidebarMinimized = e;
  }

  ngOnInit() {
    // this.locale = localStorage.getItem('locale');
    this.locale = 'fr';
    let jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
  
    if (jsonAuth !== null) {
      const data = JSON.parse(jsonAuth);
      this.selectedApplication = data.application[0].id;
    }
  
    // ✅ Appliquer la traduction et le filtrage dès le chargement
    const translatedNavs = this.navItems.map(items => {
      this.translateNav(items);
      return items;
    });
  
    const applicationId = Number(this.selectedApplication);
  
    const filteredNavs = applicationId === 7
      ? translatedNavs
      : translatedNavs.filter(item =>
          ['Dashboard', 'Competitions List', 'Members List', 'Gifts List', 'Top 50', 'Recettes', 'CGU'].includes(item?.name)
        );
  
    this.navItems = [];
    filteredNavs.forEach(val => this.navItems.push({ ...val }));
  
    // ✅ Réappliquer aussi lors d’un changement de langue
    this.translate.onLangChange.subscribe(() => {
      const translatedNavs = this.navItems.map(items => {
        this.translateNav(items);
        return items;
      });
  
      const filteredNavs = applicationId === 7
        ? translatedNavs
        : translatedNavs.filter(item =>
            ['Dashboard', 'Competitions List', 'Members List', 'Gifts List', 'Top 50', 'Recettes', 'CGU'].includes(item?.name)
          );
  
      this.navItems = [];
      filteredNavs.forEach(val => this.navItems.push({ ...val }));
    });
  }

  translateNav(item: any): void {
    const trans = this.translate.instant(`${item.name}`);
    item.name = trans;


    if (item.children && item.children.length > 0) {
      item.children.map((child: any) => this.translateNav(child));
    }
  }

  setLocale(locale: string) {

    this.locale = 'fr';

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('fr');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('fr');

    localStorage.setItem('locale', 'fr');
  }

}
